<script setup lang="ts">
interface Props {
  disabled?: boolean
  loading?: boolean
  returnRoute?: string
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  loading: false,
})
const route = useRoute()
</script>

<template>
  <header class="checkout-main-header" :class="{ loading }">
    <nuxt-link
      class="close"
      :disabled="loading"
      :to="returnRoute || `/${route.params.storefront}`"
      data-test="close-checkout-button"
      :aria-label="$t('closeIcon')"
    >
      <IconBasic filename="close" />
    </nuxt-link>

    <template v-if="route.params.view !== 'success'">
      <CheckoutNavigation />
    </template>
  </header>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';

.checkout-main-header {
  flex-shrink: 0;
  padding: 0 1rem;

  @media screen and (min-width: $phablet) {
    padding: 0 calc(20% + 1.5rem);
  }
  @media screen and (min-width: $desktop) {
    padding: 0 calc(25% + 1.5rem);
  }
  &.loading button.close {
    opacity: 0.0001;
  }
}

.close {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding: 0 1.6rem 0;
  @media screen and (min-width: $phone) {
    padding: 0 12%;
  }
  @media screen and (min-width: $phablet) {
    padding: 0 0.8rem;
  }

  .icon {
    width: 1.5rem;
    height: 1.5rem;
  }
  &:focus-visible {
    outline: 2px solid var(--black);
    outline-offset: 2px;
  }
}

@media (min-width: $tablet) {
  :deep(.mobile-only) {
    display: none;
  }
}
</style>
